<header class="fixed left-0 top-0 z-30 w-full border-b border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 backdrop-blur">
  <div class="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
    <div class="flex items-center gap-2 cursor-pointer select-none" (click)="goToHome()">
      <div class="grid h-9 w-9 place-items-center rounded-xl bg-slate-900/5 dark:bg-white/10 ring-1 ring-slate-900/10 dark:ring-white/20">
        <img src="favicon.png" alt="ConfOcean" class="h-6 w-6" />
      </div>
      <span class="text-xl font-semibold tracking-tight text-slate-900 dark:text-white">ConfOcean</span>
    </div>

    <div class="flex items-center gap-2">
      <button
        mat-icon-button
        (click)="themeService.toggleTheme()"
        [attr.aria-label]="themeService.isDark() ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
        class="w-9 h-9 rounded-lg transition-all duration-200 hover:bg-slate-100 dark:hover:bg-slate-700"
        [matTooltip]="themeService.isDark() ? 'Light Mode' : 'Dark Mode'">
        <mat-icon class="text-slate-600 dark:text-slate-300">
          {{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}
        </mat-icon>
      </button>
      <button
        class="cursor-pointer rounded-full bg-[#1e3a8a] px-4 py-2 text-sm font-semibold text-white shadow-sm shadow-blue-900/10 transition hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e3a8a]/40"
        (click)="signUp()"
      >
        Join now
      </button>
    </div>
  </div>
</header>
<app-spinner></app-spinner>
<div class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 dark:from-slate-900 dark:via-slate-900 dark:to-indigo-950 pt-24 pb-24 flex items-center">
  <div class="mx-auto w-full max-w-7xl px-4 sm:px-6">
    <div class="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
      <div class="hidden lg:flex lg:flex-col lg:justify-center">
        <div class="max-w-xl">
          <h1 class="text-4xl font-semibold tracking-tight text-slate-900 dark:text-white">Secure your account.</h1>
          <p class="mt-4 text-base leading-relaxed text-slate-600 dark:text-slate-400">
            For your security, please change your temporary password before continuing.
          </p>
          <div class="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/70 p-4 shadow-sm backdrop-blur">
              <div class="text-sm font-semibold text-slate-900 dark:text-white">Stronger protection</div>
              <div class="mt-1 text-sm text-slate-600 dark:text-slate-400">Use a unique password that meets the criteria.</div>
            </div>
            <div class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/70 p-4 shadow-sm backdrop-blur">
              <div class="text-sm font-semibold text-slate-900 dark:text-white">Quick setup</div>
              <div class="mt-1 text-sm text-slate-600 dark:text-slate-400">Update once, then sign in normally.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-center lg:justify-end">
        <div class="w-full max-w-lg">
          <div class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-800/80 p-6 shadow-xl shadow-slate-900/5 dark:shadow-black/20 backdrop-blur sm:p-8">
            <div class="flex items-center gap-3">
              <div class="grid h-10 w-10 place-items-center rounded-2xl bg-[#1e3a8a]/10 dark:bg-[#1e3a8a]/20 ring-1 ring-[#1e3a8a]/20 dark:ring-[#1e3a8a]/40">
                <img src="favicon.png" alt="ConfOcean" class="h-6 w-6" />
              </div>
              <div>
                <h2 class="text-xl font-semibold tracking-tight text-slate-900 dark:text-white">Change password</h2>
                <p class="mt-0.5 text-sm text-slate-600 dark:text-slate-400">Use your temporary password to set a new one.</p>
              </div>
            </div>

            <form
              [formGroup]="passwordForm"
              (ngSubmit)="passwordUpdate(passwordForm.value)"
              novalidate
              autocomplete="on"
              class="mt-6 space-y-4"
            >
              <div>
                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    placeholder="Temporary password"
                    formControlName="temp_password"
                    class="text-base"
                    maxlength="128"
                  />
                  <mat-icon matPrefix>lock</mat-icon>
                  <mat-error *ngIf="passwordForm.get('temp_password')?.hasError('required')">
                    Temporary password is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    [type]="password_show_and_hide ? 'text' : 'password'"
                    placeholder="New password"
                    formControlName="password"
                    class="text-base"
                    maxlength="128"
                  />
                  <mat-icon matPrefix>lock</mat-icon>
                  <button mat-icon-button matSuffix type="button" (click)="password_show_and_hide = !password_show_and_hide">
                    <mat-icon>{{ password_show_and_hide ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="passwordForm.get('password')?.hasError('required')">New password is required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    [type]="conf_password_show_and_hide ? 'text' : 'password'"
                    placeholder="Confirm password"
                    formControlName="confirm_password"
                    class="text-base"
                    maxlength="128"
                  />
                  <mat-icon matPrefix>lock</mat-icon>
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="conf_password_show_and_hide = !conf_password_show_and_hide"
                  >
                    <mat-icon>{{ conf_password_show_and_hide ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="passwordForm.get('confirm_password')?.hasError('required')">
                    Confirm password is required
                  </mat-error>
                  <mat-error *ngIf="passwordForm.hasError('passwordMismatch')">Passwords do not match</mat-error>
                </mat-form-field>
              </div>

              <div class="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 p-4">
                <div class="grid grid-cols-1 gap-2 text-xs leading-snug sm:grid-cols-2">
                  <span
                    class="flex items-center gap-2"
                    [ngClass]="{
                      'text-slate-400': passwordForm.controls['password'].pristine,
                      'text-emerald-700 dark:text-emerald-400': !passwordForm.controls['password'].hasError('minlength'),
                      'text-rose-700 dark:text-rose-400': passwordForm.controls['password'].hasError('minlength')
                    }"
                  >
                    <mat-icon class="text-base">
                      {{
                        passwordForm.controls['password'].pristine
                          ? 'info'
                          : passwordForm.controls['password'].hasError('minlength')
                            ? 'cancel'
                            : 'check_circle'
                      }}
                    </mat-icon>
                    <span>At least 8 characters</span>
                  </span>

                  <span
                    class="flex items-center gap-2"
                    [ngClass]="{
                      'text-slate-400': passwordForm.controls['password'].pristine,
                      'text-emerald-700 dark:text-emerald-400': !passwordForm.controls['password'].hasError('hasNumber'),
                      'text-rose-700 dark:text-rose-400': passwordForm.controls['password'].hasError('hasNumber')
                    }"
                  >
                    <mat-icon class="text-base">
                      {{
                        passwordForm.controls['password'].pristine
                          ? 'info'
                          : passwordForm.controls['password'].hasError('hasNumber')
                            ? 'cancel'
                            : 'check_circle'
                      }}
                    </mat-icon>
                    <span>At least 1 number</span>
                  </span>

                  <span
                    class="flex items-center gap-2"
                    [ngClass]="{
                      'text-slate-400': passwordForm.controls['password'].pristine,
                      'text-emerald-700 dark:text-emerald-400': !passwordForm.controls['password'].hasError('hasCapitalCase'),
                      'text-rose-700 dark:text-rose-400': passwordForm.controls['password'].hasError('hasCapitalCase')
                    }"
                  >
                    <mat-icon class="text-base">
                      {{
                        passwordForm.controls['password'].pristine
                          ? 'info'
                          : passwordForm.controls['password'].hasError('hasCapitalCase')
                            ? 'cancel'
                            : 'check_circle'
                      }}
                    </mat-icon>
                    <span>At least 1 uppercase letter</span>
                  </span>

                  <span
                    class="flex items-center gap-2"
                    [ngClass]="{
                      'text-slate-400': passwordForm.controls['password'].pristine,
                      'text-emerald-700 dark:text-emerald-400': !passwordForm.controls['password'].hasError('hasSmallCase'),
                      'text-rose-700 dark:text-rose-400': passwordForm.controls['password'].hasError('hasSmallCase')
                    }"
                  >
                    <mat-icon class="text-base">
                      {{
                        passwordForm.controls['password'].pristine
                          ? 'info'
                          : passwordForm.controls['password'].hasError('hasSmallCase')
                            ? 'cancel'
                            : 'check_circle'
                      }}
                    </mat-icon>
                    <span>At least 1 lowercase letter</span>
                  </span>

                  <span
                    class="flex items-center gap-2 sm:col-span-2"
                    [ngClass]="{
                      'text-slate-400': passwordForm.controls['password'].pristine,
                      'text-emerald-700 dark:text-emerald-400': !passwordForm.controls['password'].hasError('hasSpecialCharacters'),
                      'text-rose-700 dark:text-rose-400': passwordForm.controls['password'].hasError('hasSpecialCharacters')
                    }"
                  >
                    <mat-icon class="text-base">
                      {{
                        passwordForm.controls['password'].pristine
                          ? 'info'
                          : passwordForm.controls['password'].hasError('hasSpecialCharacters')
                            ? 'cancel'
                            : 'check_circle'
                      }}
                    </mat-icon>
                    <span>At least 1 special character</span>
                  </span>
                </div>
              </div>

              <button
                type="submit"
                [disabled]="!passwordForm.valid"
                class="cursor-pointer w-full rounded-full bg-[#1e3a8a] py-2.5 text-base font-semibold text-white shadow-sm shadow-blue-900/10 transition hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e3a8a]/40 disabled:opacity-50"
              >
                Update password
              </button>

              <div class="text-center text-xs text-slate-500 dark:text-slate-400">
                After updating, you'll be redirected to sign in.
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="w-full border-t border-slate-200 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 py-6 backdrop-blur md:fixed md:bottom-0 md:left-0">
  <div class="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 md:flex-row md:gap-0">
    <div class="flex items-center gap-2">
      <img src="favicon.png" alt="ConfOcean" class="h-6 w-6" />
      <span class="text-sm font-semibold text-slate-900 dark:text-white">ConfOcean</span>
      <span class="text-sm text-slate-500 dark:text-slate-400">© 2021</span>
    </div>
    <nav class="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-slate-600 dark:text-slate-400">
      <a href="https://confocean.com/user-agreement" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">User Agreement</a>
      <a href="https://confocean.com/privacy-policy" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">Privacy Policy</a>
      <a href="https://confocean.com/cookies-policy" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">Cookie Policy</a>
      <a href="https://confocean.com/copyright-policy" target="_blank" class="hover:text-slate-900 dark:hover:text-white hover:underline">Copyright Policy</a>
    </nav>
  </div>
</footer>
